import React from "react";

import clsx from "clsx";

export const Chip = ({
  className,
  text,
}: {
  className?: string;
  text: string;
}) => (
  <div
    className={clsx(
      "rounded-md bg-pluto text-white leading-0 text-xxs py-2.5 px-3",
      className,
    )}
  >
    {text}
  </div>
);
